var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDepositFill = function SvgDepositFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.58 21.6H3v-3.478z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.3 3a9.3 9.3 0 1 1 0 18.6 9.3 9.3 0 0 1 0-18.6m-1.537 9.716v-1.14H9.212v4.26h4.262v-1.55H12.11l4.163-4.162-1.46-1.459z",
    clipRule: "evenodd"
  })));
};
export default SvgDepositFill;